<template>
	<div></div>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	created() {
		//SMP-ICON Redirect login 경우 자동 로그인 처리
		//console.log('Redirecting 페이지 진입, created 호출');
		const query = this.$route.query;

		this.$sf_toggleLoading(true);
		if (!this.$sf_isEmptyObj(query)) {
			let { langCd } = query;

			 this.getLangMessage(langCd); // langCd 넣어야함

		} else {
			//console.log('Redirecting created 에러 발생');
			this.$sf_toast({ type: 'error', message: 'Access URL Error' });
		}
		this.$sf_toggleLoading(false);
	},

	computed: {
		...rootComputed
	},

	methods: {
		...rootMethods,

		GwSsoLoginAction() {
			//console.log('GW SSO LOGIN ACTION start');
			this.GwSsoLogin_()
				.then(header => {
					//console.log('GW SSO LOGIN is worked', header);
					//실패 시에만 에러 toast 창 알림
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
						// GW SSO Login 실패
						if (header.code == 2) {
							this.$router.push('/login').catch(() => {}); //login 화면 이동
							//console.log("snjung::vue3 로그인 화면 이동");
						}
					} else {
						//console.log('Redirect 해서 homeURL로 설정된곳으로 넘어갑니다. homeURL은: ', this.homeUrl, '입니다.');
						this.$router.push(this.homeUrl).catch(() => {}); //home 화면 이동
						window.location.reload();
					}
				})
				.catch(error => {
					//console.log('GW SSO LOGIN is failed', header);
					this.$sf_toast({ type: 'error', message: error.message });
				});
		},

		//query String의 언어 정보를 이용해 다국어 리스트 요청
		getLangMessage(langCd) {
			this.$sf_toggleLoading(true);

			//다국어 리스트를 요청하는 Action 호출
			this.getLangMessage_({ langCd })
				.then(header => {
					//실패 시에만 에러 toast 창 알림
					if (header.code !== 0) {
						//console.log("snjung::다국어리스트 실패",header);
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
					else
					{
						//console.log("snjung::다국어리스트 성공",header);
						this.GwSsoLoginAction();
					}

				})
				.catch(error => {
					//console.log("snjung vue4 다국어메세지 애러:",error);
					//302 에러로 인해 에러창이 발생하여, 임시로 주석처리 함
					// this.$sf_toast({
					// 	type: 'error',
					// 	message: error.message
					// });
				});
		}
	}
};
</script>
<style></style>
